import React from 'react';
import { Container } from 'reactstrap';

import routes from './clubs-routes';
import SessionRoute from '../../base/SessionRoute';

export class ClubsContainer extends React.Component {
  render() {
    return (
      <Container>
        {routes.map((route, index) => {
          return (
            <SessionRoute
              key={index}
              path={route.path}
              exact={route.exact}
              component={route.component}
              session={this.props.session}
              redirectTo={route.redirectTo}
            />
          );
        })}
      </Container>
    );
  }
}

export default ClubsContainer;
